<template>
    <div class="gty-tag" :id="defaultContainerId">
        <a :id="tooltipId">
            <span class="det_text fw-400">随机房须知</span>
            <img class="det_icon" src="https://resource.rcclchina.com.cn/tui2/info/webhao.png">
        </a>
        <b-tooltip :target="tooltipId" :container="containerId" triggers="hover" :placement="'right'"
        :boundary="'window'">
            <div>
              如预订随机舱房，请注意：
              <br/>该房型在预订时暂无法确认具体房间类型及房间号，房间分配将根据航线实际售卖情况进行，开航前将在订单详情中更新为实际房型名称及房间号。请注意关注更新信息并打印最新在线值船行程单。
              <br/>*请注意该房型中随机阳台房/随机套房有可能会被分配至遮挡房型，房型/房源不可自主挑选；如介意遮挡房型，建议直接预订其他非遮挡房型以提升入住体验。
            </div>
        </b-tooltip>
    </div>
</template>

<script>
export default {
    name: "GtyTag",
    props: {
        index: {
            type: String,
            default () {
                return ""
            }
        },
        targetContainer: {
            type: String
        }
    },
    computed: {
         tooltipId () {
            if (!this.index || this.index == '') {
                return 'gtyTag_tooltip_' + (new Date()).getTime() + Math.random(1000)
            }
            return 'gtyTag_tooltip_' +this.index
        },
        containerId () {
            if (this.targetContainer && this.targetContainer.length > 0) {
                return this.targetContainer
            }
            return this.defaultContainerId
        },
        defaultContainerId () {
            if (!this.index || this.index == '') {
                return 'gtyTag_container_' + (new Date()).getTime() + Math.random(1000)
            }
            return 'gtyTag_container_' +this.index
        }
    }
}
</script>

<style lang="less" scoped>
.gty-tag {
    display: inline-block;
    cursor: pointer;
}
.det_text {
    color: #006ab9;
}
.det_icon {
    width: 16px;
    margin-top: -2px;
    margin-left: 5px;
}
</style>